// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"UninstallPage-modulelogoContainer1o5","logo":"UninstallPage-modulelogo11f","content":"UninstallPage-modulecontent_ZF","message":"UninstallPage-modulemessage2yI"};